import { BasicWithLibelleModel } from './../basic/basicWithLibelle.model';
import { BasicModel } from '../basic/basic.model';

export class TvaModel extends BasicModel  implements BasicWithLibelleModel {
        // max length 2
        code: string;
        // max length 30
        libelle: string;
        taux: number;
        autoIntra: boolean;
        compteOd1: string = '';
        compteOd2: string = '';
        compteFact1: string = '';
        compteFact2: string = '';
        compteCompta: string = '';
        compteCompta2: string = '';
        odNTH: string = '';
        factNTH: string = '';
}
